/* eslint-disable max-len */
import React from 'react'
import SvgIcon from './SvgIcon'

export default props => {
  return (
    <SvgIcon {...props}>
      <path d="M19,10.8H8l4.9-4.9c0.5-0.5,0.5-1.3,0-1.8s-1.3-0.5-1.8,0l-7,7c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.3-0.1,0.6,0,1 c0.1,0.2,0.2,0.3,0.3,0.4l7,7c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.3,0-1.8L8,13.3h11c0.7,0,1.3-0.6,1.3-1.3 S19.7,10.8,19,10.8z" />
    </SvgIcon>
  )
}
